// Which station this copy of the app runs (each site has its own copy): name, operator, city.
// Fetched once, before login too, and shared by every screen that shows it.
import { useEffect, useState } from "react";
import api from "@/lib/api";

let cached = null;

// "#14532D" -> the site colour every brand-coloured bar and button uses (index.css --brand)
export function applyBrand(hex) {
  const m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex || "");
  if (m) document.documentElement.style.setProperty("--brand", m.slice(1).map((h) => parseInt(h, 16)).join(" "));
}
let pending = null;

function load() {
  if (!pending) {
    pending = api.get("/site").then(({ data }) => {
      cached = data;
      applyBrand(data.brand_color);
      document.title = `${data.short_name} - Shift Reconciliation`;
      return data;
    }).catch(() => (pending = null));
  }
  return pending;
}

export function useSite() {
  const [site, setSite] = useState(cached);
  useEffect(() => {
    if (!cached) load().then((d) => d && setSite(d));
  }, []);
  return site || { name: "", short_name: "", operator: "", city: "" };
}
